/*
    Tagを生成するコンポーネント
    props
        label:タグの表示文言
        enable:アクティブ表示と非アクティブ表示の切り替えの真偽値
 */

import React from "react"

interface DataSource {
  label: string,
  disable?: boolean,
}

interface Props {
  dataSources: DataSource[] | DataSource[] | string[] | string[][],
}

export function Tags(props: Props) {
  const { dataSources } = props
  const tags = []
  if (dataSources.length) {
    if (Array.isArray(dataSources[0])) {
      if (typeof dataSources[0][0] === "string") {
        tags.push(
          ...dataSources.map(item =>
            item.map(tag => {
              return {
                label: tag,
                disable: false
              }
            })
          )
        )
      } else {
        tags.push(...dataSources)
      }
    } else {
      if (typeof dataSources[0] === "string") {
        tags.push([
          ...dataSources.map(tag => {
            return {
              label: tag,
              disable: false
            }
          })
        ])
      } else {
        tags.push([...dataSources])
      }
    }
    return (
      <>
        <div className="point-area">
          {tags.map((dataSource, lineIndex) =>
            <div className="point-row" key={`tag-${lineIndex}`}>
              {dataSource.map((tag, index) => {
                return (
                  <React.Fragment key={`tag-${lineIndex}-${index}`}>
                    <div className={tag.disable ? "no-point" : "point"}>
                      {tag.label}
                    </div>
                  </React.Fragment>
                )
              })}
            </div>
          )}
        </div>
      </>
    )
  } else {
    return <></>
  }

}